var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"w"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.pInfo)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }